import React from 'react';

import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { getColorObjectStyleByRecord } from 'PDF/helpers/documentStyle';
import { ISalesPlanDetailsProductRowProps } from 'PDF/pages/MarketingAndSales/types';

import { formatNumber } from 'helpers/numbers';

const colorIndexes = {
  green: 7,
  blue: 7,
  red: 7,
  blueGreen: 6,
  blueRed: 7,
  blueYellow: 7,
};

export const SalesPlanDetailsProductRow: React.FC<ISalesPlanDetailsProductRowProps> = ({ row }) => {
  return (
    <View style={styles.productRow}>
      <View style={styles.row}>
        <View style={styles.titleWrap}>
          <Text style={[styles.titleText, getColorObjectStyleByRecord(colorIndexes, 'color')]}>{row.productName}</Text>
        </View>
      </View>
      {row.characteristics?.map((item, index) => {
        const isLast = index === row.characteristics.length - 1;
        return (
          <View key={index} style={styles.row}>
            <View style={styles.titleWrap}>
              <Text style={[styles.info, isLast ? styles.bold : {}]}>{item.title}</Text>
            </View>
            {item.values?.map((value, index) => (
              <View key={index} style={styles.ceil}>
                <Text style={[styles.info, styles.infoText, isLast ? styles.bold : {}]}>{formatNumber(+value, 1)}</Text>
              </View>
            ))}
          </View>
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  ceil: {
    width: '100%',
    paddingRight: '1px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  productRow: {
    display: 'flex',
    flexDirection: 'column',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    borderBottom: '0.25px solid #C5C6C8',
    height: '16px',
    padding: '0 4px',
  },
  titleWrap: {
    minWidth: '154.64px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  titleText: {
    fontFamily: 'Noto',
    fontWeight: 600,
    fontSize: '9px',
  },
  info: {
    fontFamily: 'Noto',
    fontWeight: 300,
    fontSize: '9px',
    color: '#000',
  },
  infoText: {
    marginLeft: 'auto',
  },
  bold: {
    fontWeight: 600,
  },
});
